var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "record-con",
      class: { "large-font-mode": _vm.pageData.largeFontMode },
    },
    [
      _c(
        "div",
        { staticClass: "header-con flex flex-row align-center w-full" },
        [
          _c("span", { staticClass: "date" }, [
            _vm._v(_vm._s(_vm._f("DateTimeToDate")(_vm.info.diagTime))),
          ]),
          _c("el-tag", { attrs: { size: "small" } }, [
            _vm._v(_vm._s(_vm.info.storeUserName)),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "body-con flex flex-col",
          class: { "large-font-mode": _vm.pageData.largeFontMode },
        },
        [
          _c("div", { staticClass: "record-item flex flex-col" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "content flex flex-col background-gary" },
              [
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("主诉")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.symContent)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("四诊")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.fdmContent)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("中医诊断")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.info.chYndromeContent +
                            " " +
                            _vm.info.chDiagContent
                        )
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "item flex flex-row align-center" }, [
                  _c("div", { staticClass: "label" }, [_vm._v("西医诊断")]),
                  _c("div", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.info.diagContent)),
                  ]),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "record-item flex flex-col" }, [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "content flex flex-col background-gary" },
              [
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("体温")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.temperature)),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("血压")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.info.lowPressure + "/" + _vm.info.highPressure
                        )
                      ),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "item flex flex-row align-center mb-8" },
                  [
                    _c("div", { staticClass: "label" }, [_vm._v("血糖")]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.info.bloodSugar)),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
          _c("div", { staticClass: "record-item flex flex-col" }, [
            _c(
              "div",
              {
                staticClass:
                  "label-con flex flex-row align-center justify-between",
              },
              [
                _vm._m(2),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled:
                        _vm.copyBtnDisabled ||
                        ["2"].indexOf(
                          _vm.pageData.activeDiagRecord.diagRecord.stateSign
                        ) === -1,
                      type: "primary",
                      size: "small",
                    },
                    on: { click: _vm.copyTreatment },
                  },
                  [_vm._v("复制 ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "content w-full" }, [
              _c(
                "div",
                {
                  staticClass:
                    "head-con flex flex-row align-center justify-between w-full",
                },
                [
                  _c(
                    "div",
                    { staticClass: "tab-con w-full" },
                    [
                      _c(
                        "el-tabs",
                        {
                          attrs: { "tab-position": "left" },
                          on: { "tab-click": _vm.handleTabChange },
                          model: {
                            value: _vm.activeTab,
                            callback: function ($$v) {
                              _vm.activeTab = $$v
                            },
                            expression: "activeTab",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "饮片处方", name: "1" } },
                            [
                              _c("treatment-record", {
                                ref: "chmed",
                                attrs: {
                                  url: "clinic/treatment/treatment/chmedprescription",
                                },
                                on: { command: _vm.handleTreatmentCommand },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "中成药处方", name: "2" } },
                            [
                              _c("treatment-record", {
                                ref: "med",
                                attrs: {
                                  "med-code": "medPrescriptionItem",
                                  url: "clinic/treatment/treatment/medprescription",
                                },
                                on: { command: _vm.handleTreatmentCommand },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "理疗处方", name: "3" } },
                            [
                              _c("treatment-record", {
                                ref: "liliaomed",
                                attrs: {
                                  "med-code": "servePrescriptionItem",
                                  url: "clinic/treatment/treatment/serveprescription",
                                },
                                on: { command: _vm.handleTreatmentCommand },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "代煎处方", name: "4" } },
                            [
                              _c("treatment-record", {
                                ref: "djmed",
                                attrs: {
                                  "med-code": "chagentPrescriptionItem",
                                  url: "pharmacy/storage/agentpre/chagentprescription",
                                },
                                on: { command: _vm.handleTreatmentCommand },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "代售处方", name: "5" } },
                            [
                              _c("treatment-record", {
                                ref: "dsmed",
                                attrs: {
                                  "med-code": "agentPrescriptionItem",
                                  url: "pharmacy/storage/agentpre/agentprescription",
                                },
                                on: { command: _vm.handleTreatmentCommand },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("span", { staticClass: "label" }, [_vm._v("诊断记录")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "label-con flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("span", { staticClass: "label" }, [_vm._v("体格记录")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex flex-row align-center" }, [
      _c("div", { staticClass: "icon" }),
      _c("div", { staticClass: "label" }, [_vm._v("治疗")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }